import React, { useState } from 'react';
import { Button } from '@fieldnation/platform-components';
import classNames from 'classnames';

import styles from './styles.scss';
import { Part, PartUsage } from './types.d';
import AddPart from './AddPart';
import { isPartDraftValid } from './utils';

interface Props {
  initialPart: Part;
  initialUsage: PartUsage;
  isEditing: boolean;
  onCancel: () => void;
  onSave: (part: Part, usage: PartUsage, addAnother: boolean) => void;
  className?: string;
}

const PartCard = ({
  initialPart,
  initialUsage,
  isEditing,
  onCancel,
  onSave,
  className,
}: Props): JSX.Element => {
  const [part, setPart] = useState<Part>(initialPart);
  const [usage, setUsage] = useState<PartUsage>(initialUsage);
  const [isUniqueExternalId, setIsUniqueExternalId] = useState<boolean>(true);

  const canSave = isPartDraftValid(part) && isUniqueExternalId;

  return (
    <div className={classNames(styles['part-container'], className)}>
      <p className={styles['card-header']}>{isEditing ? 'Edit part' : 'Add part'}</p>
      <p className={styles['card-subtitle']}>
        Enter details about the part being shipped for this work order.
      </p>
      <AddPart
        newPart={part}
        setNewPart={setPart}
        usageData={usage}
        setUsageData={setUsage}
        isUniqueExternalId={isUniqueExternalId}
        setIsUniqueExternalId={setIsUniqueExternalId}
      />
      <div className={styles['card-footer']}>
        <Button
          id="cancelPartButton"
          label="Cancel"
          type="secondary"
          onClick={onCancel}
        />
        {!isEditing && (
          <Button
            id="saveAndAddAnotherPartButton"
            label="Save & add another"
            type="secondary"
            disabled={!canSave}
            onClick={() => onSave(part, usage, true)}
          />
        )}
        <Button
          id="savePartButton"
          label="Save"
          type="primary"
          disabled={!canSave}
          onClick={() => onSave(part, usage, false)}
        />
      </div>
    </div>
  );
};

PartCard.defaultProps = {
  className: undefined,
};

export default PartCard;
